import React from "react";

import "./SideDrawer.css";

const sideDrawer = (props) => {
  let drawerClasses = "side-drawer";
  if (props.show) drawerClasses = "side-drawer open";

  return (
    <nav className={drawerClasses}>
      <br /> <br />
      <ul>
        <li className="nav-item mr-1">
          <a href="https://codeops.tech/#jetbrainstools">JetBrains Tools</a>
        </li>
        <hr />
        <li className="nav-item mr-1">
          <a href="https://codeops.tech/#consulting">Consulting</a>
        </li>
        <hr />
        <li className="nav-item mr-1">
          <a href="https://codeops.tech/#products">Products</a>
        </li>
        <hr />
        <li className="nav-item mr-1">
          <a href="https://codeops.tech/#trainings">Trainings</a>
        </li>
        <hr />
      </ul>
    </nav>
  );
};

export default sideDrawer;
